import CheckIcon from '@mui/icons-material/Check';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import type { ConstValues } from '@openx/types/helpers';
import type { ReactNode } from 'react';

export const Status = {
  SUCCESS: 'success',
  LOADING: 'loading',
} as const;
export type Status = ConstValues<typeof Status>;

const IconWrapper = ({ children }: { children: ReactNode }) => {
  return <Box sx={{ minWidth: 22, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{children}</Box>;
};

type ThinkingStatusIconProps = {
  status: Status;
  message: string;
};

export const ThinkingStatusIcon = ({ status, message }: ThinkingStatusIconProps) => {
  if (status === Status.SUCCESS) {
    return (
      <>
        <IconWrapper>
          <CheckIcon sx={{ height: 18, color: theme => theme.palette.action.disabled }} aria-label="Loading…" />
        </IconWrapper>

        <Typography
          variant="body1"
          component="div"
          sx={{
            color: theme => theme.palette.action.disabled,
            fontWeight: theme => theme.typography.fontWeightRegular,
          }}
        >
          {message}
        </Typography>
      </>
    );
  }

  return (
    <>
      <IconWrapper>
        <CircularProgress enableTrackSlot size={15} aria-label="Loading…" />
      </IconWrapper>

      <Typography
        variant="body1"
        component="div"
        sx={{
          fontWeight: theme => theme.typography.fontWeightRegular,
        }}
      >
        {message}
      </Typography>
    </>
  );
};
